module.exports = __webpack_public_path__ + "img/logo-eloyalfaro.eb78ff96.png";